import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWinter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 73,
	height: 73,
	viewBox: "0 0 73 73",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_43_114)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M45.65 1.78998L36.21 36.08",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.59 9.28996L40.14 3.20996",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.59 9.28996L49.67 5.82996",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.62 16.46L36.07 6.69",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.62 16.46L51.38 10.91",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M39.64 23.63L32.26 10.64",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M39.64 23.63L52.63 16.25",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.77 70.37L36.21 36.08",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.83 62.88L32.28 68.96",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.83 62.88L22.75 66.34",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.81 55.71L36.35 65.47",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.81 55.71L21.04 61.26",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.78 48.53L40.16 61.53",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.78 48.53L19.79 55.92",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70.63 27.12L36.21 36.08",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M63.11 29.08L66.65 23.05",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M63.11 29.08L69.14 32.61",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55.91 30.95L61.59 21.27",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55.91 30.95L65.6 36.63",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.71 32.83L56.27 19.94",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.71 32.83L61.6 40.38",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.78998 45.05L36.21 36.08",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.30996 43.09L5.76996 49.12",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.30997 43.0901L3.27997 39.5601",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.51 41.21L10.83 50.9",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.51 41.21L6.82001 35.54",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.71 39.34L16.15 52.22",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.71 39.34L10.83 31.78",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M61.19 61.41L36.21 36.08",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55.73 55.87L62.72 55.92",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55.7301 55.87L55.6801 62.86",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50.5 50.58L61.73 50.66",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50.5001 50.58L50.4301 61.81",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M45.28 45.28L60.22 45.39",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M45.2801 45.28L45.1801 60.22",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.23 10.76L36.21 36.08",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.69 16.29L9.70001 16.24",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.69 16.29L16.74 9.29999",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.92 21.59L10.69 21.51",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.92 21.59L21.99 10.36",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.14 26.89L12.2 26.78",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.14 26.89L27.24 11.95",
				stroke: "white",
				strokeWidth: 3.58,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_43_114",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 72.42,
			height: 72.17,
			fill: "white"
		})
	}) })]
});
export default SvgWinter;
